module.exports = __webpack_public_path__ + "static/media/account_balance-black-18dp.d48bdd75.svg";